import jwt_decode from 'jwt-decode';

import Service from '@/lib/App';
import { getToken } from '@/utils/localStorage';

export function getLoggedUserEmail(): string {
  const concedoEmail = Service.cache.getUserInfo()?.email;
  if (concedoEmail) {
    return concedoEmail;
  }

  const ssoEmail = Service.cache.getSSOUserInfo()?.email;
  if (ssoEmail) {
    return ssoEmail;
  }

  const token = getToken();
  if (token) {
    try {
      const decoded = jwt_decode(token) as any;
      if (decoded?.attr?.UserEmail?.[0]) {
        return decoded.attr.UserEmail[0];
      }
    } catch (e) {
      // ignore
    }
  }

  return '';
}

export function isAdmin(): boolean {
  return Service.cache.isUserAdmin();
}
